import React from "react";
import styles from '../styles.module.scss';
import TickSvg from "../../../components/svg/TickSvg";
import Try, {TryBtn} from "../../../components/Try";

export default function SolutionsA() {
  return <>
    <section className={styles.head}>
      <div className={styles.headContent}>
        <div className={styles.title}>
          <h4>科创企业是券商重要战略资源</h4>
          <h1>券商科创金融<br />解决方案</h1>
          <Try />
        </div>
        <div className={styles.sticker} style={{marginLeft: "165px"}}><img src="./static-official/images/sticker-s-d.png" height={533} alt="私募股权投资" /></div>
      </div>
    </section>
    <section className={styles.commonSection0}>
      <div className={styles.detailContainer}>
        <div className={styles.detailBlock} style={{width: "385px"}}>
          <h3>一二级联动数据工具</h3>
          <desc>为券商投行、投资、研究等多部门提供数据与模型服务，基于非上市公司数据表现挖掘优质企业客户，结合上市公司对外投资挖掘服务商机。</desc>
          <ul>
            <li><h4><TickSvg />投行：上市预备企业与高潜力客户挖掘</h4></li>
            <li><h4><TickSvg />投资：赋能私募股权投资、另类投资业务</h4></li>
            <li><h4><TickSvg />研究：一级市场、上市公司对外投资分析</h4></li>
          </ul>
          <TryBtn />
        </div>
        <img src="./static-official/images/s-d.png" alt="一二级联动数据工具" height={468}/>
      </div>
    </section>
  </>
}
